import { Daytable } from '@aclass/core/base/daytable';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fromTimestamp'
})

export class TimestampPipe implements PipeTransform {

    /**
     * @inheritDoc
     */
    transform(value: any): Date | undefined {
        const dt = Daytable.fromTimestamp(value);

        return dt ? dt.toDate() : undefined;
    }
}
